import PubSub from "./pubsub.js";
import anime from "./anime.es.js";

/////////////////
// SEARCH TOGGLE
/////////////////
if (!customElements.get("search-toggle")) {
  class SearchToggle extends HTMLElement {
    constructor() {
      super();
      this.pubsub = PubSub;

      this.searchToggle = this.querySelector(".search-toggle");
      this.iconSearch = this.querySelector(".icon-search");
      // this.iconX = this.querySelector(".icon-x");

      this.state = {
        searchToggle: false,
      };
    }

    _handleClick = (e) => {
      e.preventDefault();

      // this.iconSearch.classList.add("hidden");
      // this.iconX.classList.toggle("hidden");

      this.pubsub.pub("search-toggle:click", !this.state.searchToggle);
      this.state.searchToggle = !this.state.searchToggle;
    };

    _closeButton = () => {
      this.state.searchToggle = false;
      this.pubsub.pub("search-toggle:click", false);
    };

    connectedCallback() {
      this.searchToggle.addEventListener("click", this._handleClick.bind(this));
      this.pubsub.sub("search-toggle:close", this._closeButton.bind(this));
    }
    disconnectedCallback() {}
  }

  customElements.define("search-toggle", SearchToggle);
}

///////////////
// SEARCH PANEL
///////////////
if (!customElements.get("search-panel")) {
  class SearchPanel extends HTMLElement {
    constructor() {
      super();
      this.pubsub = PubSub;

      this.abortController = new AbortController();

      this.searchPanel = this.querySelector(".search-panel");
      this.searchPanelInput = this.querySelector(".search-panel-input");
      this.searchPanelResults = this.querySelector(".search-panel-results");
      this.searchPanelOverlay = this.querySelector(".search-panel-overlay");
    }

    handleSearchToggle = (data) => {
      // TOGGLE SEARCH DISPLAY & OVERLAY

      data === true
        ? document.body.classList.add("overflow-hidden")
        : document.body.classList.remove("overflow-hidden");

      data === true
        ? this.searchPanel.classList.remove("hidden")
        : this.searchPanel.classList.add("hidden");

      data === true
        ? this.searchPanelOverlay.classList.remove("hidden")
        : this.searchPanelOverlay.classList.add("hidden");
    };

    connectedCallback() {
      // this.searchPanelInput.addEventListener(
      //   "input",
      //   debounce((event) => {
      //     this.getSearchResults(event.target.value);
      //   }, 500).bind(this)
      // );

      this.pubsub.sub(
        "search-toggle:click",
        this.handleSearchToggle.bind(this)
      );
    }
    disconnectedCallback() {}
  }

  customElements.define("search-panel", SearchPanel);
}
